import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('@investor/views/Login.vue')
        },
        {
            path: '/login',
            name: 'login',
            async beforeEnter(to, from, next) {
                try {
                    const {data} = await router.app.$http.get('/api/investor/public/web-settings', {});
                    if (data.useNewOnboardingLogin && data.onboardingBaseUrl) {
                        window.location = data.onboardingBaseUrl
                    } else {
                        next()
                    }
                } catch (e) {
                    next()
                }
            },
            component: () => import('@investor/views/Login.vue')
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: () => import('@investor/views/RedirectionFromOnboarding.vue')
        },
        {
            path: '/authentication',
            name: 'authentication',
            component: () => import('@investor/views/TwoFactorAuthentication.vue')
        },
        {
            path: '/logout',
            name: 'logout',
            component: () => import('@investor/views/Logout.vue')
        },
        {
            path: '/forgot-password',
            name: 'forgot-password',
            component: () => import('@investor/views/ForgotPassword.vue')
        },
        {
            path: '/reset-password/:token',
            name: 'reset-password',
            component: () => import('@investor/views/ResetPassword.vue')
        },
        {
            path: '/registration/:step',
            name: 'registration',
            component: () => import('@investor/views/registration/RegistrationSimple.vue')
        },
        {
            path: '/email-verification',
            name: 'email-verification',
            component: () => import('@investor/views/registration/EmailVerification.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/complete-email-verification/:token',
            name: 'complete-email-verification',
            component: () => import('@investor/views/registration/CompleteEmailVerification.vue'),
        },
        {
            path: '/status-verification',
            name: 'status-verification',
            component: () => import('@investor/views/profile/StatusVerification.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/status-verification/rejected',
            name: 'status-verification-rejected',
            component: () => import('@investor/views/profile/StatusVerificationRejected.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/profile-phone-verification',
            name: 'profile-phone-verification',
            component: () => import('@investor/views/profile/PhoneVerification.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/document-verification',
            name: 'document-verification',
            component: () => import('@investor/views/profile/DocumentVerification.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
         {
            path: '/poi-upload',
            name: 'poi-upload',
            component: () => import('@investor/views/profile/POIUpload.vue')
        },
        {
            path: '/veriff',
            name: 'veriff',
            component: () => import('@investor/views/profile/Veriff.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/bank-account',
            name: 'bank-account',
            component: () => import('@investor/views/profile/BankAccount.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/profile-personal-details',
            name: 'profile-personal-details',
            component: () => import('@investor/views/profile/PersonalDetails.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/rejected',
            name: 'rejected',
            component: () => import('@investor/views/registration/Rejected.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/accept-terms',
            name: 'accept-terms',
            component: () => import('@investor/views/profile/AcceptTerms.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@investor/views/profile/Dashboard.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/account-statement',
            name: 'account-statement',
            component: () => import('@investor/views/profile/AccountStatement.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/tranche-listing-prev',
            name: 'tranche-listing-prev',
            component: () => import('@investor/views/profile/TrancheListing.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/tranche-listing',
            name: 'tranche-listing',
            component: () => import('@investor/views/profile/TrancheListing2.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/borrowers',
            name: 'borrowers',
            component: () => import('@investor/views/profile/Borrowers.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/autoinvestment',
            name: 'autoinvestment',
            component: () => import('@investor/views/profile/Autoinvestment.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/autoinvestment/strategy/:strategyUuid?',
            name: 'autoinvestment-strategy',
            component: () => import('@investor/views/profile/AutoinvestmentStrategy.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/tranche-invest-prev/:trancheUuid',
            name: 'tranche-invest-prev',
            component: () => import('@investor/views/profile/TrancheInvest.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/tranche-invest/:trancheUuid',
            name: 'tranche-invest',
            component: () => import('@investor/views/profile/TrancheInvest2.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/wallet',
            name: 'wallet',
            component: () => import('@investor/views/profile/Wallet.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/settings',
            name: 'settings',
            component: () => import('@investor/views/profile/Settings.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/borrower/:borrowerUuid',
            name: 'borrower',
            component: () => import('@investor/views/profile/Borrower.vue'),
            meta: {
                requiresInvestor: true,
            }
        },
        {
            path: '/lead-registration',
            name: 'lead-registration',
            component: () => import('@investor/views/registration/LeadRegistration.vue')
        },
        {
            path: '/lead-registration-success',
            name: 'lead-registration-success',
            component: () => import('@investor/views/registration/LeadRegistrationSuccess.vue')
        },
        {
            path: '*',
            redirect: {name: 'login'}
        }
    ]
})

router.beforeEach(async (to, from, next) => {
    await Vue.nextTick()
    router.app.$trackPage(to);

    if (to.matched.some(record => record.meta.requiresInvestor)) {
        const $authToken = router.app.$authToken;
        const $fetchInvestorProfile = router.app.$fetchInvestorProfile;
        const $resolveInvestorRoutes = router.app.$resolveInvestorRoutes;

        if (!$authToken()) {
            next({to: '/'});
            return;
        }

        await $fetchInvestorProfile();
        const allowedRoutes = $resolveInvestorRoutes()
        if (allowedRoutes.indexOf(to.name) >= 0) {
            next();
        } else {
            const forcedRoute = allowedRoutes[0];
            console.log(`Redirecting to ${forcedRoute}`);
            next({path: `/${forcedRoute}`})
        }
    } else {
        next()
    }
})

export default router;
